export default __webpack_public_path__ + "static/media/linkedin.4356055e.svg";